import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import Apis from '@/Apis/_'

interface NetPromoterScoreQuestion {
  id: string,
  question: string,
  showQuestion: boolean
}

@Module({ namespaced: true, name: 'NetPromoterScoreStore' })
export default class NetPromoterScoreStore extends VuexModule {
  public netPromoterScoreQuestion: NetPromoterScoreQuestion = {
    id: '',
    question: '',
    showQuestion: false,
  }

  @Action
  async getNetPromoterScoreQuestion() {
    try {
      const surveyQuestionRequest = await Apis.FeedbackAPI.FeedbackAPI.getPerguntaDoFeedback()
      if (surveyQuestionRequest.success) {
        const { id, texto, exibePerguntaDeFeedback } = surveyQuestionRequest.data
        this.context.commit('setNetPromoterScoreQuestion', {
          id,
          question: texto,
          showQuestion: exibePerguntaDeFeedback,
        })
      }
      return surveyQuestionRequest
    } catch (error) {
      this.context.commit('setNetPromoterScoreQuestion', { id: '', question: '', showQuestion: false })

      return { success: false, message: 'Ocorreu um erro na solicitação.' }
    }
  }

  @Action
  async answerNetPromoterScoreSurvey(answerPayload) {
    try {
      const parsedAnswerPayload = {
        perguntaId: answerPayload.id,
        ignorou: answerPayload.dismissed,
        texto: answerPayload.answer,
        nota: answerPayload.rating,
      }
      return await Apis.FeedbackAPI.FeedbackAPI.usuarioRespondeFeedback(parsedAnswerPayload)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na solicitação.' }
    }
  }

  @Mutation
  setNetPromoterScoreQuestion(netPromoterScoreQuestion: NetPromoterScoreQuestion) {
    this.netPromoterScoreQuestion = netPromoterScoreQuestion
  }
}
